import React, { useState } from "react";

// react bootstrap
import { Accordion } from "react-bootstrap";

// hooks react bootstrap
import { useAccordionButton } from "react-bootstrap/AccordionButton";

// react icons
import { MdOutlineAdd } from "react-icons/md";
import { RiSubtractLine } from "react-icons/ri";

const ButtonAcordion = ({ icon, eventKey, setActive }) => {
  const decoratedOnClick = useAccordionButton(eventKey, () =>
    setActive((prev) => !prev)
  );

  return (
    <button
      className="border-none background-none"
      type="button"
      onClick={decoratedOnClick}
    >
      {icon}
    </button>
  );
};

export const AccordionGeo = ({ id_ayuda, nombre, descripcion }) => {
  const [active, setActive] = useState(false);

  return (
    <Accordion>
      <div
        className={`lbl-titulos-acordion-ayudas${
          active ? "_active" : "_inactive"
        }`}
      >
        <ButtonAcordion
          key={id_ayuda}
          icon={
            active ? (
              <RiSubtractLine color="#fff" size={"17px"} className="mb-2" />
            ) : (
              <MdOutlineAdd color="#909090" size={"17px"} className="mb-2" />
            )
          }
          eventKey={id_ayuda}
          setActive={setActive}
        />
        {nombre}
      </div>
      <Accordion.Collapse eventKey={id_ayuda}>
        <div className="conten-pregunta-frecuente">{descripcion}</div>
      </Accordion.Collapse>
    </Accordion>
  );
};
